export { default } from "./AIExpandableTextArea";
